module.exports = __webpack_public_path__ + "media/icon/icon-hot_tub-gray-dac03fa3.svg";